import ToolEditProvider from './ToolEditContext';
import ToolEdit from './ToolEdit';

let Index = () => {
    return (
        <ToolEditProvider>
            <ToolEdit />
        </ToolEditProvider>
    )
}

export default Index;